<template>
	<v-dialog v-model="isVisible" :max-width="maxWidth">
		<p-card class="tw-p-none overflow-hidden">
			<p-header-dialog
				:search="search"
				:negative-margin="false"
				@closeClicked="close()">
				{{ title }}
			</p-header-dialog>
			<slot name="content"></slot>
		</p-card>
	</v-dialog>
</template>

<script>
import PCard from '@/modules/shared/components/ui/Card/p-card';
import PHeaderDialog from '@/modules/job-profile/components/content/p-header-dialog';

function created() {
}

export default {
	name: 'PModal',
	created,
	components: {
		PCard,
		PHeaderDialog,
	},
	data() {
		return {
			isVisible: false,
		};
	},
	props: {
		maxWidth: {
			type: Number,
			default: 400,
		},
		search: {
			type: Boolean,
			default: false,
		},
		title: {
			type: String,
			default: '',
		},
	},
	methods: {
		open() {
			this.isVisible = true;
		},
		close() {
			this.isVisible = false;
		},
	},
	computed: {
	},
	watch: {
	},
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/modules/shared/components/ui/p-modal.vue